import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.bl{gap:8px;}.ssr-plugin'
import '.gz{height:120px;}.ssr-plugin'
import '.h0{vertical-align:center;}.ssr-plugin'
import '.h1{font-size:0px;}.ssr-plugin'
import '.e2{padding:8px;}.ssr-plugin'
import '.ez{overflow-y:auto;}.ssr-plugin'
import '.f0{overflow-x:hidden;}.ssr-plugin'
import '.h2{max-width:100%;}.ssr-plugin'
import '.df{display:inline-flex;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.e3{padding:4px;}.ssr-plugin'
import '.h3{cursor:not-allowed;}.ssr-plugin'
import '.h4{margin-bottom:8px;}.ssr-plugin'
import '.b3{margin-right:8px;}.ssr-plugin'
import '.de{outline:none;}.ssr-plugin'
import '.gh{width:2px;}.ssr-plugin'
import '.a1{height:100%;}.ssr-plugin'
import '.da{flex-shrink:0;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.af{gap:4px;}.ssr-plugin'
import { useState } from 'react'
import { Button } from '../Button/index.js'
import { Modal } from '../Modal/index.js'
import { TextInput } from '../TextInput/index.js'
import { SelectInput, SelectInputProps } from '../SelectInput/index.js'
import { NumberInput } from '../NumberInput/index.js'
import { DateInput } from '../DateInput/index.js'
import { Icon, IconProps } from '../Icon/index.js'
import { Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { LabelDescription } from '../LabelDescription/index.js'

type StringTagInputProps = {
  variant: 'string'
  value?: string[]
  onChange: (value: string[]) => void
}
type NumberTagInputProps = {
  variant: 'number'
  value?: number[]
  onChange: (value: number[]) => void
}
type BooleanTagInputProps = {
  variant: 'boolean'
  value?: boolean[]
  onChange: (value: boolean[]) => void
}
type EnumTagInputProps = {
  variant: 'enum'
  value?: string[]
  onChange: (value: string[]) => void
  options: SelectInputProps['options']
}
type DateTimeTagInputProps = {
  variant: 'date-time'
  value?: number[]
  onChange: (value: number[]) => void
}

type TagInputProps = (
  | StringTagInputProps
  | NumberTagInputProps
  | BooleanTagInputProps
  | EnumTagInputProps
  | DateTimeTagInputProps
) & {
  disabled?: boolean
  label?: string
  description?: string
  error?: boolean
  errorMessage?: string
  placeholder?: string
  placeholderIcon?: IconProps['variant']
}

const TagInput = (props: TagInputProps) => {
  const value = props.value ?? []
  const [editIndex, setEditIndex] = useState<number>()
  const [editValue, setEditValue] = useState<string | number | boolean>()

  return (
    <LabelDescription
      label={props.label}
      description={props.description}
      error={props.error && props.errorMessage}
    >
      <div className="a i h bl"
      >
        <styled.div className="h gz h0 h1 e2 ez f0"
          style={{
            borderRadius: radius[12],
            border: `1px solid ${colors.neutral20Adjusted}`,
            ...(props.error && {
              border: `1px solid ${colors.red80}`,
            }),
            ...(props.disabled && {
              cursor: 'not-allowed',
              color: colors.neutral20,
              background: colors.neutral5,
              border: `1px solid transparent`,
            }),
          }}
        >
          {Boolean(value?.length) &&
            value.map((val, index) => (
              <styled.div className="h2 df b e3 h3 h4 b3 de"
                onClick={() => {
                  if (props.disabled) return
                  setEditIndex(index)
                  setEditValue(val)
                }}
                style={{
                  borderRadius: radius[6],
                  background: colors.neutral10Adjusted,
                  color: colors.neutral20,
                  ...(!props.disabled && {
                    color: colors.neutral80,
                    cursor: 'pointer',
                    '&:hover': {
                      background: colors.neutral20Adjusted,
                    },
                  }),
                }}
              >
                <div className="gh a1 da"
                />
                <Text singleLine variant="subtext-medium" color="inherit">
                  {props.variant === 'date-time'
                    ? new Date(val as number).toLocaleString()
                    : val.toString()}
                </Text>
                <div className="gh a1 da"
                />
                <styled.div className="da a b c h3"
                  onClick={(e) => {
                    if (props.disabled) return
                    e.stopPropagation()
                    props.onChange(value.filter((_, i) => i !== index) as any)
                  }}
                  style={{
                    borderRadius: radius[6],
                    ...(!props.disabled && {
                      cursor: 'pointer',
                      '&:hover': {
                        background: colors.neutral20Adjusted,
                      },
                    }),
                  }}
                >
                  <Icon variant="close" size="small" />
                </styled.div>
              </styled.div>
            ))}
          {Boolean(!value?.length) && (
            <div className="h a1 c b a i af"
              style={{
                color: colors.neutral60,
              }}
            >
              {props.placeholderIcon && (
                <Icon variant={props.placeholderIcon} />
              )}
              {props.placeholder && (
                <Text variant="subtext-medium" color="inherit">
                  {props.placeholder}
                </Text>
              )}
            </div>
          )}
        </styled.div>

        <div className="a bl">
          <Modal size="small">
            <Modal.Trigger>
              <Button
                leadIcon="add"
                variant="border"
                onClick={() => {
                  setEditIndex(undefined)
                  setEditValue(undefined)
                }}
                disabled={props.disabled}
              >
                Add {props.variant}
              </Button>
            </Modal.Trigger>
            <Modal.Content>
              <Modal.Header
                title={
                  typeof editIndex === 'number'
                    ? `Edit ${props.variant}`
                    : `Add ${props.variant}`
                }
              />
              <Modal.Body>
                {props.variant === 'string' && (
                  <TextInput
                    value={editValue as string}
                    onChange={setEditValue}
                    autoFocus
                  />
                )}
                {props.variant === 'number' && (
                  <NumberInput
                    value={editValue as number}
                    onChange={setEditValue}
                    autoFocus
                  />
                )}
                {props.variant === 'boolean' && (
                  <SelectInput
                    value={editValue as boolean}
                    onChange={setEditValue}
                    options={[
                      { value: true, label: 'True' },
                      { value: false, label: 'False' },
                    ]}
                  />
                )}
                {props.variant === 'enum' && (
                  <SelectInput
                    value={editValue as string}
                    onChange={setEditValue}
                    options={props.options}
                  />
                )}
                {props.variant === 'date-time' && (
                  <DateInput
                    value={editValue as number}
                    onChange={setEditValue}
                    variant="date-time"
                  />
                )}
              </Modal.Body>
              <Modal.Footer>
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button
                    variant="border"
                    onClick={() => Modal.Close()}
                    keyHint="Esc"
                  >
                    Cancel
                  </Button>
                  <Button
                    keyHint="Enter"
                    disabled={typeof editValue === 'undefined'}
                    onClick={() => {
                      if (typeof editIndex !== 'undefined') {
                        props.onChange(
                          value.map(
                            (e, i) => (i === editIndex ? editValue : e) as any,
                          ),
                        )
                      } else {
                        props.onChange([...value, editValue as any])
                      }
                      Modal.Close()
                      setEditValue(undefined)
                      setEditIndex(undefined)
                    }}
                  >
                    {editIndex ? 'Save' : 'Add'}
                  </Button>
                </div>
              </Modal.Footer>
            </Modal.Content>
          </Modal>
        </div>
      </div>
    </LabelDescription>
  )
}

export { TagInput }
export type { TagInputProps, EnumTagInputProps }
